<template>
  <div class="edit-container">
    <div
      class="edit-container__body g-edit-component"
    >
      <div class="edit-container__steps-wrapper">
        <ol class="edit-container__steps">
          <li
            v-for="(step, index) in ModalData.data.steps"
            :key="index"
            class="edit-container__steps__step"
            @click="stepButtonClick(index + 1)"
          >
            <button
              class="g-btn g-btn--rounded edit-container__steps__step__text"
              :class="['edit-container__steps__step__text--'+step.state]"
            >
              <span v-if="Step < ModalData.data.steps.length && !computedConfigured">
                {{ index + 1 }}
              </span> {{ step.name }}
            </button>
          </li>
        </ol>

        <button
          v-if="Step < ModalData.data.steps.length && !computedConfigured"
          title="Continue to the next editing step"
          class="g-btn g-btn--rounded edit-container__continue"
          @click="continueButtonClick"
        >
          continue
          <font-awesome-icon :icon="['fas', 'arrow-circle-right']" />
        </button>
      </div>
      <div class="edit-container__header">
        <h2>Station: {{ station.name }}</h2>
      </div>
      <component
        :is="computedCurrentStep.component"
        v-if="computedCurrentStep"
        :socket-message="SocketMessage"
        :station="station"
        :store = "store"
        @SetPageMessage="SetPageMessage"
      />
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle, MicroService} from '@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

/** Stations */
import EditStationParameters from'@/components/EditStationParameters'
import EditStationBasicLandscape from'@/components/EditStationBasicLandscape'
import EditStationAdvanced from'@/components/EditStationAdvanced'
import EditStationSprinklers from'@/components/EditStationSprinklers'

export default {
  name: 'EditStations',
  components:
  {
    'font-awesome-icon': FontAwesomeIcon,
    'edit-station-parameters': EditStationParameters,
    'edit-station-basic-landscape': EditStationBasicLandscape,
    'edit-station-advanced': EditStationAdvanced,
    'edit-station-sprinklers': EditStationSprinklers
  },
  mixins: [SocketHandler, LifeCycle, MicroService],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      Step: 0,
      MaxStep: 0,
      Steps: [],
      station: {}
    }
  },
  computed:
  {
    computedConfigured() {
      return isEmpty(this.ModalData.data.data.Configured) ? true : this.ModalData.data.data.Configured
    },
    computedCurrentStep() {
      return this.ModalData.data.steps[this.Step - 1]
    },
    GetCurrentName() {
      let returnMsg = ''
      if(this.Step !== undefined && this.ModalData.data.steps[this.Step - 1] !== undefined) {
        returnMsg = this.ModalData.data.data.name + ' - ' + this.ModalData.data.steps[this.Step - 1].name
      }
      return returnMsg
    },
    StepButtonText() {
      return (this.Step !== this.ModalData.data.steps.length) ? 'Continue' : 'Done' 
    }
  },
  watch: {
    station: {
      handler(val) {
        // console.debug('updating station')
        Object.assign(this.ModalData.data.data, {
          name: val.name,
          description: val.description,
          expectedFlow: val.expectedFlow,
          precip: val.precip,
          status: val.status
        })

        this.$emit('SetPageMessage', {
          target: 'Stations',
          data: {
            rerender: true
          }
        })

      }, deep: true
    },
    Step() {
      this.MaxStep = (this.Step > this.MaxStep) ? this.Step : this.MaxStep
      this.ModalData.data.steps.forEach((step, stepIndex) => {
        if(stepIndex <= this.MaxStep - 1) {
          if (stepIndex === this.Step - 1) {
            step.state = 'active'
          } else {
            step.state = 'completed'
          }
        } else if(stepIndex <= this.MaxStep) {
          step.state = 'completed'
        } else {
          step.state = 'disabled'
        }
      })
    }
  },
  created() {
    this.Step = 1
    this.MaxStep = this.ModalData.data.steps.length
    this.getMicroServiceStationsData()
  },
  methods: {
    getMicroServiceStationsData() {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/auth/decoders?decId=${this.ModalData.data.data.StId}`
      })
      .then((response) => {
        if(response.data && response.data.length) {
          this.$set(this, 'station', response.data[0])
          // this.station = Object.assign(this.ModalData.data.data, response.data[0])
        } else {
          console.error(response)
        }
      }).catch(console.error)
    },
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    continueButtonClick() {
      if(this.Step < this.ModalData.data.steps.length) {
        this.Step += 1
      }
    },
    stepButtonClick(StepIndex) {
      if(StepIndex <= this.MaxStep || StepIndex <= this.MaxStep + 1) {
        this.Step = StepIndex
      }
    }
  }
}
</script>

<style lang="scss">
  %button-modifier {
    border-radius: $application-base-border-radius;
    border-bottom-left-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin: 0 2px;
    height: 40px;
    transform: translate3d(-2px, 0, 0);
    box-shadow: 0 -3px 3px -2px $color-grey-dark inset;
    border: 0;
  }

  .edit-container {
    $max-width: 900px;
    position: relative;
    max-width: $max-width;
    overflow: hidden;

    hr {
      margin: 0;
      border: 0;
      border-top: 1px solid lighten($color-black, 90);
      background: transparent;
    }

    .edit-station {
      transition: all 1s;
      background: $color-white;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      grid-gap: 20px;
      padding: 10px 10px;

      &__title, label {
        display: block;
        margin: 5px;
        font-size: 14px;
        font-family: 'Montserrat-SemiBold';
        font-weight: normal;

        + .input-element {
          padding-top: 0;
        }
      }

      &__toggle {
        &.active div {
          transition: color 1s;
          transition-delay: 1s;
          background-color: lighten($color-red-error, 40);
          &::after {
            content: '';
            background-color: $color-red-error;
          }
        }
      }
    }

    .edit-grid {
      display: grid;
      grid-gap: 10px;
      grid-template-columns: repeat(2, 1fr);
      max-width: 400px;

      > * {
        display: flex;
        align-items:center;
        margin: 0;
        flex-wrap: nowrap;
      }

      
      &__title h5 {
        margin: 5px 0;
      }

      .input-element {
        margin-right: 10px;
        padding: 10;
        &__name {
          margin: 0;
          &__input {
            text-align: center;
            width: calc(100% - 18px);
          }
        }
      }

      .select-element {
        width: 100%;
        select {
          margin: 10px 0;
        }
      }
    }

    &__header {
      background: $color-white;
      padding: 20px 0 15px;
      border-bottom: 1px solid $color-grey;

      h2 {
        margin: 0 0 0 15px;
        padding-bottom: 2px;
      }
    }

    &__body {
      width: 100vw;
      max-width: $max-width;
      padding-bottom: 100px;
      transition: all 1s;
      background: transparent !important;
    }

    &__error {
      box-sizing: border-box;
      background: $color-white;
      padding: 10px 20px;
      max-width: $max-width;
      min-width: 200px;
      width: 100%;
      border-radius: $application-base-border-radius !important;
      line-height: 18px;

      p {
        margin-bottom: 0;
      }

      &__action {
        text-align: center;
      }

      .g-btn {
        margin: 20px auto;
      }
    }

    &__continue {
      $size: 33px;
      border: 0;
      font-size: $size;
      padding: 0 2px 0 8px;
      margin: 0 !important; // @TODO: No !important
      font-size: 13px;
      display: flex;
      align-items: center;
      border-radius: $application-base-border-radius !important;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;

      > * {
        font-size: $size * 0.75;
        top: 0;
        left: 0;
        color: $color-button-blue;
        border: 2px solid $color-white;
        border-radius: 50%;
        margin-left: 5px;
      }
    }

    &__steps-wrapper {
      display: flex;
      align-items: stretch;
      // padding: 10px 20px;

      >* {
        margin: 0;
      }
    }

    &__steps {
      width: 100%;
      &__step {
        width: 100%;
        button {
          text-align: left;
        }
        .g-btn {
          width: 100%;
          @extend %button-modifier;
        }
        &__text {
          color: lighten($color-grey-darker, 10);
          span {
            display: inline-block;
            $size: 18px;
            text-align: center;
            width: $size;
            height: $size;
            border: 1px solid $color-grey-darker;
            border-radius: 50%;
          }
          &--active {
            color: $color-button-blue;
            font-family: $font-primary-semibold;
          }

          &--completed {
            color: $color-grey-darker;
          }

          &--disabled {
            color: $color-grey !important; // @TODO: No !important
            cursor: default;
          }
        }
      }
    }

  }

  @media screen and (min-width: $bp-mobile) {
    .edit-container {
      &__body {
        width: 85vw !important;
      }
    }
  }

  @media screen and (min-width: $bp-tablet - 1) {
    .edit-container {
      &__header {
        border-top-right-radius: $application-base-border-radius;
      }
      &__steps {
        width: auto;
        &__step {
          display: inline-block;
          width: auto;
          button {
            text-align: center;
          }
          .g-btn {
            width: auto;
          }
          &__text {
            &--active {
              box-shadow: none !important;
            }
          }
        }
      }
    }
  }
</style>
